<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/aboutUs/02/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="f-a-j-j page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="f-a-j-j-content">
                            <div class="title">
                                <span>在招</span>
                                <span>职位？</span>
                            </div>
                            <auto-row class="max-size list flex-column">
                                <auto-col class="list-item" v-for="(item,index) of z_w_list" :key="index">
                                    <div class="titles flex-items-center">
                                        <div class="title flex-1">{{item.title}}</div>
                                        <div class="flex-items-center pointer" @click="showMore(index)">
                                            <img :style="item.isMore == true ? 'transform: rotate(180deg);transition: all .3s;' : 'transform: rotate(0deg);transition: all .3s;'" src="@/assets/image/aboutUs/02/zhankai.png" height="20" width="14" alt="">
                                            <div class="arrow-text">{{item.isMore ? '收起' : '展开'}}</div>
                                        </div>
                                    </div>
                                    <div class="flex-justify-center infos">
                                        <div class="info">工作地点：{{item.address}}</div>
                                        <div class="info">职位性质：{{item.type}}</div>
                                        <div class="info">发布时间：{{item.publishDate}}</div>
                                    </div>
                                    <div class="post" :class="item.isMore == false ? '' : 'post-more' " :style="item.isMore == false ? 'height: 0; overflow-y: hidden;' : ''">
                                        <div class="post-title">岗位职责</div>
                                        <div v-for="(item1,index1) of item.content_1" :key="index1+100">
                                            <div class="post-item">{{item1}}</div>
                                        </div>
                                        <div class="post-title">岗位要求</div>
                                        <div v-for="(item2,index2) of item.content_2" :key="index2+200">
                                            <div class="post-item">{{item2}}</div>
                                        </div>
                                    </div>
                                </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
            <div class="f-f-j-y page-content-child">
                <div class="">
                    <div class="page-content-box add-us">
                        <img src="@/assets/image/aboutUs/02/content-bg.png" class="max-size add-us-imgs"  data-fit-cover alt="">
                        <div class="add-us-info">
                            <h3 class="title">朗数科技</h3>
                            <div class="text">期待你的加入！</div>
                            <div class="vita pointer">简历发送：HR@launchso.com</div>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="page-content-child"-->
<!--                v-for="(src,i) of imgArr"-->
<!--                :key="i"-->
<!--            >-->
<!--                <div class="content-w">-->
<!--                    <img :src="src" width="100%" alt="" />-->
<!--                </div>-->
<!--            </div>-->
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/aboutUs/02/pic-1.png'),
                    require('@/assets/image/aboutUs/02/pic-2.png'),
                ],
                z_w_list:[
                    {
                        title:'Java高级软件工程师',
                        isMore:false,
                        address:'武汉',
                        type:'全职',
                        publishDate:'2023-02-28',
                        content_1:['1、理解客户需求，并根据需求进行程序设计、开发、测试，解决软件缺陷，保证质量；','2、能独立处理和解决所负责的工作任务；','3、进行编制项目文档和质量记录的工作；','4、维护软件使之保持可用性和稳定性；'],
                        content_2:[
                            '1、计算机及相关专业***专科以上学历,3年以上软件开发经验(从毕业后计算)，年龄在25岁至35岁。' ,
                            '2、前端:熟练掌握Vue/JQuery，熟练使用基于Vue/JQuery前端框架(easyUI,ElementUI,iView),并能独立打包发布；' ,
                            '3、熟练掌握Spring MVC 和Spring Boot框架；' ,
                            '4、熟练掌握SQL语句，了解基本的优化(有证书的优先考虑)；',
                            '5、熟练使用MAVEN、SVN、JIRA等项目管理工具；',
                            '6、具备2个以上中大型项目经验，有企业ERP、电商系统、智慧养老、智慧医疗等经验优先；'
                        ]
                    },
                    {
                        title:'项目经理',
                        isMore:false,
                        address:'武汉',
                        type:'全职',
                        publishDate:'2023-02-28',
                        content_1:['1、项目管理与控制：项目实施中对项目推动和控制，负责项目整体规划统筹，制订项目开发、实施方案，安排项目工作任务；','2、项目月度验收指标：根据项目经理月度计划制定验收指标，带领项目团队按计划完成各项任务；','3、项目规范执行度：能够按照主动性的按照规范要求执行项目以及项目交付物提交，负责分析整理客户的各类需求，负责对已修改的需求及程序问题调整后的程序测试及交付客户的工作；',
                            '4、计划与报告执行力：日报、周报、月报、季报提交和执行准确度以及及时性；','5、客户问题解决和跟踪，确保客户满意度，确保零投诉；','6、协调和指导项目实施工程师进行实施工作；督促项目开发、实施进度，保证项目可以按时完工；',
                            '7、提协调处理项目开发、实施中出现的各类意外问题；'
                        ],
                        content_2:[
                            '1、大学本科及以上学历，计算机相关专业；5年以上工作经验，其中项目经理经验3年以上，有Java基础为佳；' ,
                            '2、有从事企业IT工作、企业管理信息系统导入、用户培训经验；具有OA、ERP、MES系统实施、维护、培训方面的经验者优先；' ,
                            '3、具备良好的SQLserver、Oracle等数据库的操作和维护知识和维护能力，有一定的技术（html编写）基础；了解企业级服务器常用软件环境的基本操作；' ,
                            '4、具备良好自信心，有较强的口头表达能力；',
                            '5、有强烈的进取精神、事业心、责任心；抗压能力强；',
                            '6、能够适应短期出差；'
                        ]
                    },
                    {
                        title:'Vue前端开发工程师',
                        isMore:false,
                        address:'武汉',
                        type:'全职',
                        publishDate:'2023-02-28',
                        content_1:['1、负责公司产品/项目移动端和PC端的前端研发工作，解决核心技术问题；','2、根据开发进度和任务分配，完成相应模块软件的开发、功能测试任务，高质量的交付；','3、根据业务需求，封装高复用、可维护性好的前端组件；',
                            '4、负责前端页面的系统优化，设计并完善前端基础服务架构；','5、理解产品业务的基础上，提升产品用户体验，技术驱动业务发展；'
                        ],
                        content_2:[
                            '1、熟悉多种前端框架，熟悉angular、VUE、bootstrap，echart等；' ,
                            '2、3年以上前端开发经验，其中有2年VUE开发经验，使用过element UI，layui做过项目；' ,
                            '3、有企业信息化系统、电商平台、视频监控、数字大屏项目优先考虑；' ,
                            '4、精通HTML5、CSS3、JavaScript，熟悉后台开发框架，能与后台工程师（java）密切协作；',
                            '5、对浏览器的兼容性有一定了解，并有相关问题的解决经验；',
                            '6、学习能力强，喜欢研究新技术，有团队观念，具备独立解决问题的能力；'
                        ]
                    },
                    {
                        title:'产品经理',
                        isMore:false,
                        address:'武汉',
                        type:'全职',
                        publishDate:'2023-02-28',
                        content_1:['1、负责产品的全过程管理，包括收集用户需求分析、市场和竞争分析、制定产品规划、设计产品功能并跟进开发、测试上线流程；','2、把握产品的美术风格，规划UI详细功能需求；','3、撰写详细的产品需求文档，并不断完善；',
                            '4、参与制定开发计划，跟进解决研发过程中遇到的问题；','5、对产品质量负责，负责编写测试计划、测试用例、测试场景、参与测试，编写操作手册；',
                            '6、跟踪技术及产品发展潮流，结合用户及业务需求提出产品优化及创新需求，为新产品的开发提供合理建议；',
                            '7、接受中短期出差；'
                        ],
                        content_2:[
                            '1、 3年以上工作经验，2年以上大型软件产品项目或互联网产品需求分析经验；' ,
                            '2、 熟悉需求调研方法，较强的业务流程及业务模型分析设计能力；' ,
                            '3、 善于控制需求，进行版本范围及项目范围管理；丰富的客户（及内部）沟通经验，能快速把握需求的核心要点；' ,
                            '4、 熟悉软件工程理论，掌握软件需求获取与分析方法，至少熟悉一种开发语言和一种数据库，有软件开发经验者优先；',
                            '5、 有较强的文档编写能力；熟悉CMMI文档规范者优先；',
                            '6、 有较强的团队协作精神，具备良好的学习能力，责任心强，能够承受较大的工作压力；',
                            '7、熟练使用AXURE、mockplus、墨刀，office等办公软件；',
                            '8、具备2个以上中大型项目经验，有企业ERP、电商系统、智慧养老、智慧医疗等经验优先；'
                        ]
                    }
                ],
                // isMore:false,//查看更多
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            },
            showMore(index) {
                this.z_w_list.forEach((item,idx)=>{
                    index === idx ? item.isMore = !item.isMore : ''
                })
            },
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }

    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(n){
        background: #F9F9F9;
    }
    /*.page-content-child:nth-child(2n+2){*/
    /*    background-color: #082334;*/
    /*}*/

    .page-content-child .title span:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }
    .page-content-child .title span:nth-child(2){
        color:#2FA8D0;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }

    .f-a-j-j .f-a-j-j-content{
        text-align: center;
        padding:102px 0 314px 0;
    }


    .f-a-j-j .list{
        text-align: center;
        background: #ffffff;
        margin-top:27px;
    }

    .f-a-j-j .list-item{
        text-align: left;
        padding:54px 50px 40px;
        position: relative;
    }

    .f-a-j-j .list-item:before {
         content: ' ';
         position: absolute;
         bottom:0;
         height: 2px;
         border-top: 1px solid #E7E7E7;
         background-color: #E7E7E7;
         color: #E7E7E7;
         transform: scaleY(0.5);
         transform-origin: 0 100%;
         right: 50px;
         left: 50px;
     }

    .f-a-j-j .list-item:last-child:before {
         display: none;
     }


    .f-a-j-j .list-item .title{
        font-size: 24px;
        color: #333333;
        font-weight: bold;
    }
    .f-a-j-j .arrow-text{
        font-size: 24px;
        font-weight: 400;
        color: #2FA8D0;
        margin-left:16px;
    }

    .f-a-j-j .infos{
        padding-top:48px;
        font-size: 24px;
        font-weight: 400;
        color: #555555;
        line-height: 1;
        transition: all .3s;
    }

    .infos .info:nth-child(1){
        width: 33.33%;
    }
    .infos .info:nth-child(2){
        width: 33.33%;
        text-align: center;
    }
    .infos .info:nth-child(3){
        width: 33.33%;
        text-align: right;
    }

    .post{
        transition: all .3s;
    }

    .post .post-title{
        font-size: 24px;
        font-weight: 550;
        color: #555555;
        margin-top:55px;
    }

    .post .post-item{
        font-size: 24px;
        color: #555555;
        margin-top:15px;
        line-height: 1.6;
        transition: all .3s;
    }

    .post .post-item:hover{
        transform: translateY(-5px);
    }

    .post-more{
        transition: all .3s!important;
    }

    .add-us-imgs{
        width:100%;
        max-height:600px;
        min-height:300px;
        overflow:hidden;
        vertical-align: middle;
    }

    .add-us{
        position: relative;
    }

    .add-us .add-us-info{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
    }

    .add-us .add-us-info .title{
        font-size: 40px;
        font-weight: 550;
        color: #333333;
        line-height: 1;
        letter-spacing: 32px;
        transition: all .3s;
    }
    .add-us .add-us-info .text{
        font-size: 40px;
        font-weight: 300;
        color: #333333;
        line-height: 1;
        margin-top: 58px;
        letter-spacing: 32px;
        transition: all .3s;
    }

    .add-us .add-us-info .vita{
        padding:24px 100px;
        background: #2FA8D0;
        border-radius: 10px;
        text-align: center;
        margin: auto 0;
        font-size: 34px;
        font-weight: 400;
        color: #FFFFFF;
        margin-top:58px;
        white-space: nowrap;
        transition: all .3s;
    }

    .add-us .add-us-info .title:hover,.add-us .add-us-info .text:hover,.add-us .add-us-info .vita:hover{
        transform: translateY(-5px);
    }


    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:110px 0 200px 0;
        }

        .add-us .add-us-info .text{
            margin-top: 40px;
        }

        .add-us .add-us-info .vita{
            padding:20px 90px;
            margin-top:40px;
        }

    }

    @media screen and (max-width: 960px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:90px 0 100px 0;
        }

        .f-a-j-j .infos{
            display: flex;
            flex-flow: column nowrap;
            padding-top:28px;
        }
        .infos .info:nth-child(1){
            width: 100%;
        }
        .infos .info:nth-child(2){
            width: 100%;
            text-align: left;
            padding-top: 20px;
        }
        .infos .info:nth-child(3){
            width: 100%;
            text-align: left;
            padding-top: 20px;
        }

        .add-us .add-us-info .text{
            margin-top: 28px;
        }

        .add-us .add-us-info .vita{
            padding:18px 90px;
            margin-top:28px;
        }

    }

    @media screen and (max-width: 760px){
        .f-a-j-j .f-a-j-j-content{
            text-align: center;
            padding:70px 0 80px 0;
        }

        .f-a-j-j .infos{
            display: flex;
            flex-flow: column nowrap;
            padding-top:28px;
        }
        .infos .info:nth-child(1){
            width: 100%;
        }
        .infos .info:nth-child(2){
            width: 100%;
            text-align: left;
            padding-top: 20px;
        }
        .infos .info:nth-child(3){
            width: 100%;
            text-align: left;
            padding-top: 20px;
        }

        .add-us .add-us-info .text{
            margin-top: 20px;
        }

        .add-us .add-us-info .vita{
            padding:12px 80px;
            margin-top:20px;
        }

    }
</style>
